export default __webpack_public_path__ + "static/media/PowellCatLocation-16.72eb0057.jpg";